import { render, staticRenderFns } from "./SettingsCard.vue?vue&type=template&id=4e09ec52&scoped=true"
import script from "./SettingsCard.vue?vue&type=script&lang=js"
export * from "./SettingsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e09ec52",
  null
  
)

export default component.exports